import { useAppNavigate } from 'app-layered-layout/useAppNavigate'
import { useNavigateTo } from './useNavigateTo'
import { useSelector } from 'react-redux'
import { selectGameUserStatus } from 'redux/selector/game'
import { useGameBanCheck } from './useGameBanCheck'
import { useIpBanCheck } from './useIpBanCheck'
import { useOpenGamePopup } from './useOpenGamePopup'
import { selectNavigationContent } from 'redux/selector/app'
import { useNavigationLocalData } from 'component/Navigation/hooks/useNavigationLocalData'
import { ShortcutJumpType } from 'component/ShortcutBox/constant'
import { fetchPostAdEvent } from 'api'
import { formatDate } from 'utils/timeFormat'
import useOpenModal from 'component/ShortcutBox/component/Shortcut/hooks/useOpenModal'
import { SchemaCmsIconuiShow } from 'api/generated'
import { GAME } from 'constant/routers'

export const useShortcutBoxHandler = () => {
  const { openActorListModal, openProducerListModal, openEnableVipModal } = useOpenModal()
  const { navigateToProducer, navigateToActor } = useNavigateTo()
  const navigate = useAppNavigate()

  // game
  const gameUserStatus = useSelector(selectGameUserStatus)
  const { validateUser } = useGameBanCheck(gameUserStatus)
  const { validateIpBan } = useIpBanCheck()
  const openGamePopup = useOpenGamePopup()

  // nav
  const navigationContent = useSelector(selectNavigationContent)
  const localData = useNavigationLocalData()

  const jumpToInternalLink = (info: SchemaCmsIconuiShow) => {
    /**
     *   jump_type  integer
     *   跳轉類型(1:片商, 2:演員, 3:片商列表, 4:演員列表, 5:開通VIP, 6: 鏈結, 7: NAV, 8: 遊戲)
     */
    const {
      jump_type,
      video_actor_id,
      video_producer_id,
      // name,
      game_platform,
      game_type_id,
      direction,
      internal_id,
      outside_url,
    } = info

    switch (jump_type) {
      case ShortcutJumpType.Producer:
        // 如果是特定片商，直接使用Producer頁
        if (video_producer_id) {
          navigateToProducer({
            producerId: video_producer_id,
            // producerImage: info?.icon_path,
            // producerName: name,
            // producerImageSource: 'picture',
          })
        }
        break
      case ShortcutJumpType.Actor:
        if (video_actor_id) {
          navigateToActor({ actorId: video_actor_id })
        }
        break
      case ShortcutJumpType.ProducerList:
        openProducerListModal?.()
        break
      case ShortcutJumpType.ActorList:
        if (video_actor_id) {
          openActorListModal?.({ video_actor_id })
        }
        break
      case ShortcutJumpType.EnabledVIP:
        openEnableVipModal?.()
        break
      case ShortcutJumpType.Link:
        if (outside_url) {
          window.open(outside_url, '_blank')
        }
        break
      case ShortcutJumpType.Game:
        if (internal_id) {
          validateIpBan(() => {
            validateUser(() => {
              openGamePopup({
                id: Number(internal_id),
                ...(game_platform
                  ? {
                      gameType: game_type_id,
                      tpCode: game_platform,
                      direction: direction,
                    }
                  : {}),
              })
            })
          })
        }
        break
      case ShortcutJumpType.Nav:
        if (internal_id) {
          const index = navigationContent.findIndex((i: any) => i.id === internal_id)

          if (index < 0) {
            return
          }

          const target = localData.navContent[index]

          if (target) {
            const navigateToTarget = () =>
              navigate(target.navLink + target.search, { replace: true, forceReplaceNonCurrentPage: true })

            if (target.navLink === GAME) {
              validateIpBan(navigateToTarget)
            } else {
              navigateToTarget()
            }
          }
        }
        break
      default:
        break
    }
  }

  function logClickEvent(info: SchemaCmsIconuiShow) {
    try {
      fetchPostAdEvent({
        date: formatDate(new Date()),
        material_id: 10000,
        material_name: info.name || '',
        oholo_site_id: 10000, // 固定值
        // @ts-ignore - oholoer_id is not in SchemaCmsIconuiShow but was used in JS
        oholoer_id: info.oholoer_id,
      })
    } catch (ex) {
      console.warn('Error at log click event', ex)
    }
  }

  /**
   * 處理跳轉邏輯
   * @param {SchemaCmsIconuiShow} info
   */
  const chooseRedirectFunction = (info: SchemaCmsIconuiShow) => {
    const { jump_method, outside_url } = info

    switch (jump_method) {
      /** 跳轉內部鏈接 */
      case 1:
        jumpToInternalLink(info)
        break
      /** 跳轉外部鏈接 */
      case 2:
        logClickEvent(info)
        if (outside_url) {
          window.open(outside_url)
        }
        break
      default:
        break
    }
  }

  return chooseRedirectFunction
}
